import React from "react";
import styles from "./passwordInput.module.css"
import eye from "../../../images/eye-icon.svg";
import eyeOff from "../../../images/eye-icon-off.svg";

import { useState } from "react";

export const PasswordInput = (props) => {
    const {placeholder, name} = props;
    const [password, setPassword] = useState("");
    const [inputType, setType] = useState('password');
    const [icon, setIcon] = useState(eyeOff);

    const handleToggle = () => {
        if (inputType==='password'){
           setIcon(eye);
           setType('text');
        } else {
           setIcon(eyeOff);
           setType('password');
        }
     }
      const handleChange = (evt) => {
        setPassword(evt.target.value);
        if (props.onChange) {
            props.onChange(evt);
        }
        
      }
    
    return (
        <label className = { styles.passInputWrapper }>
            <input
                  type={inputType}
                  name={name}
                  placeholder={placeholder}
                  value={password}
                  onChange={handleChange}
                  autoComplete="current-password"
                  className={ styles.passwordInput }
             />
             <span onClick={handleToggle}>
                <img src={icon} alt="Show pass"/>
            </span>
        </label>
    )
}